import { type Resource } from '../../models/resource';
import { type ResourceTypes } from '../../models/resource.types';

export abstract class ResourceMapper {
    public static readonly type: ResourceTypes;

    public abstract map(resource: Resource): unknown;
}
